export const WEIGHT_ID = "0";
export const ENERGY_ID = "111";
export const ENERGY_CAL_ID = "1069";